module.exports = __webpack_public_path__ + "img/sendShip.6231272f.png";